import { DESKTOP_SCREEN_WIDTH } from '@common/constants';
import { useMediaQuery } from 'react-responsive';

export const useIsDesktop = () => {
  return useMediaQuery({ minWidth: DESKTOP_SCREEN_WIDTH });
};
